import React from 'react'
import styled from 'styled-components'
import { useDrag } from 'react-dnd'
import toast from 'react-hot-toast'
import { SESSION_EXPIRED_MESSAGE } from '../../../../../../config/wpSession'
import { ItemTypes } from '../../../../constants'

function Image(props) {
  const ImageContainer = styled.div`
    margin-bottom: 10px;
    width: 100%;
    height: auto;
    display: block;
    position: relative;
  `

  const Image = styled.img`
    margin-bottom: 10px;
    width: 100%;
    height: auto;
    display: block;
  `

  const ImageOverlay = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.7;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: center;
  `

  const ImageOverlayText = styled.div`
    font-family: Hind;
    font-size: 12px;
    color: white;
    text-transform: uppercase;
    letter-spacing: 1px;
  `

  const onDrop = (item, dropResult, saveSubmission, createBoard) => {
    const imageId = item.image.id
    const isLead = dropResult.placementObject === 'lead'
    const sectionIndex = isLead ? null : dropResult.placementObject[0]
    const imageIndex = isLead ? null : dropResult.placementObject[1]
    // STY-625: both the placement and its rollback go through saveSubmission as
    // functions, so each one runs against the document as it stands at that
    // moment. Mutating a captured `additionalInfo` and posting it back is what
    // let a rollback several seconds later revert a placement it knew nothing
    // about — see the note on PostBuilderContainer.saveSubmission.
    saveSubmission(doc => {
      if (isLead) {
        doc.leadImage = imageId
      } else {
        doc.sections[sectionIndex].images[imageIndex].images.push(imageId)
      }
      return doc
    })

    // The placement above is the authoritative save; the toast belongs to it,
    // not to the board.
    toast.success('Image added to post')

    // STY-635: warm the board and forget it. The publish path
    // (smp_post_from_submission_2) builds every board it needs, so a failed warm
    // costs nothing but a slower import later. It must never touch the document:
    // the old rollback deleted a placement whenever the warm failed, which is
    // how a WordPress logout (STY-634) and a saturated image server
    // (2026-09-11) both looked to the editor like "my images keep vanishing".
    createBoard(imageId)
      .catch((err) => {
        if (err && err.wpSessionExpired) {
          toast.error(SESSION_EXPIRED_MESSAGE)
          return
        }
        const status = err && err.response && err.response.status
        console.warn(`[post-builder] board warm failed for image ${imageId}` + (status ? ` (HTTP ${status})` : ''), err && err.message)
      })
  }

  const { isUsed, saveSubmission, createBoard, image, src } = props

  const [{isDragging}, drag] = useDrag(() => ({
    type: ItemTypes.IMAGE,
    item: { image },
    end(item, monitor) {
      const dropResult = monitor.getDropResult()
      if (item && dropResult) {
        onDrop(item, dropResult, saveSubmission, createBoard)
      }
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    })
  }), [image, saveSubmission])

  return (
    <ImageContainer>
      <Image
        ref={drag}
        style={{ opacity: isDragging ? 0.2 : 1, cursor: isDragging ? 'move' : 'initial' }}
        src={src}
      />
      {isUsed && <ImageOverlay><ImageOverlayText>Used</ImageOverlayText></ImageOverlay>}
    </ImageContainer>
  )
}

export default Image


